import { Prisma, MediaLevel } from '.prisma/client';
import { Category } from '@/prisma/utils/categories';
import { MediaLevels } from '@/prisma/utils/media-levels';
import { MediaType } from '@/prisma/utils/media-type';
import { Tag } from '@/prisma/utils/tag';
import {
	FormControl,
	FormLabel,
	Input,
	Select,
	Text,
	Textarea,
} from '@chakra-ui/react';
import React, { ChangeEvent, ChangeEventHandler } from 'react';
import CategorySelectControl from '../category/select-control';
import TagFormControl from '../tag/form-control';

type PlaylistFormProps = {
	name?: string;
	onNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
	description?: string | null;
	onDescriptionChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
	type?: MediaType | undefined;
	types: MediaType[];
	onTypeChange: (type: MediaType) => void;
	level?: MediaLevel;
	levels: MediaLevels;
	onLevelChange: (e: ChangeEvent<HTMLSelectElement>) => void;
	// duration: number;
	// durations: number[];
	// onDurationChange: (e: ChangeEvent<HTMLSelectElement>) => void;
	categories: Category[];
	selectedCategories?: Category[];
	onCategoriesChange: (categories: Category[]) => void;
	tags?: Tag[];
	onTagsChange: (tags: (Tag | Prisma.TagCreateInput)[]) => void;
	mediaUrls: string; // TODO: change to array or something
	onMediaUrlsChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
	initialRef: React.MutableRefObject<HTMLInputElement | null>;
	errorMessage: string;
};

export const PlaylistForm: React.FC<PlaylistFormProps> = ({
	name,
	onNameChange,
	description,
	onDescriptionChange,
	type,
	types,
	onTypeChange,
	level,
	levels,
	onLevelChange,
	mediaUrls,
	onMediaUrlsChange,
	initialRef,
	errorMessage,
	...props
}) => {
	const handleTypeChange: ChangeEventHandler<HTMLSelectElement> = (
		e: ChangeEvent<HTMLSelectElement>
	) => {
		const target = e.target as HTMLSelectElement;

		const type = types.find((t) => t.slug === target.value);

		if (type) {
			onTypeChange(type);
		}
	};

	return (
		<>
			<FormControl>
				<FormLabel>Name</FormLabel>
				<Input
					ref={initialRef}
					placeholder="Name this playlist"
					value={name}
					onChange={onNameChange}
				/>
			</FormControl>
			<FormControl mt={4}>
				<FormLabel>Description</FormLabel>
				<Textarea
					placeholder="Describe this playlist"
					value={description || ''}
					onChange={onDescriptionChange}
				/>
			</FormControl>
			<FormControl mt={4}>
				<FormLabel>Type of yoga</FormLabel>
				<Select
					value={type && type.slug}
					onChange={handleTypeChange}
				>
					<option>Select a type of yoga</option>
					{types.map((_mt) => (
						<option
							key={_mt.id}
							value={_mt.slug}
						>
							{_mt.name}
						</option>
					))}
				</Select>
			</FormControl>
			<FormControl mt={4}>
				<FormLabel>Level</FormLabel>
				<Select
					value={level as string}
					onChange={onLevelChange}
				>
					<option>Select a level</option>
					{levels.map((_ml) => (
						<option
							key={_ml.key}
							value={_ml.value}
						>
							{_ml.value}
						</option>
					))}
				</Select>
			</FormControl>
			<CategorySelectControl
				categories={props.categories}
				selectedCategories={props.selectedCategories}
				onCategoriesChange={props.onCategoriesChange}
			/>
			<TagFormControl
				tags={props.tags}
				onTagsChange={props.onTagsChange}
			/>
			<FormControl mt={4}>
				<FormLabel>Media</FormLabel>
				<Textarea
					placeholder="Enter urls of media you'd like to add to this playlist"
					value={mediaUrls}
					onChange={onMediaUrlsChange}
				/>
			</FormControl>
			<Text
				my={4}
				color="red"
			>
				{errorMessage}
			</Text>
		</>
	);
};
